import MagLogo from './mag-logo.png';
import { Popover } from 'mag-react-components';

export default function Sources({ selectedLayer }) {
  const blockGroupsDefinition =
    'A Census Block Group is a geographical unit between the Census Tract and the Census Block. It is the smallest geographical unit for which the Census bureau publishes sample data.';

  const tractsDefinition =
    "A Census Tract are small, relatively permanent statistical subdivisions of a county or equivalent entity that are updated by local participants prior to each decennial census as part of the Census Bureau's Participant Statistical Areas Program. Census tracts generally have a population size between 1,200 and 8,000 people, with an optimum size of 4,000 people.";
  return (
    <>
      <div style={{ fontSize: '10px', fontStyle: 'italic', fontWeight: '800' }}>
        <hr />
        <p>
          FY2021 HUD Income Limits Summary, FY 2021 Income Limits Documentation
          System -- Summary for Maricopa County, Arizona (
          <a href="https://huduser.gov" target="_blank" rel="noreferrer">
            huduser.gov
          </a>
          ){' '}
        </p>
        <p>
          American Community Survey by{' '}
          {selectedLayer === 'BlockGroups' ? 'Block Group' : 'Tract'}{' '}
          <Popover
            style={{ display: 'inline-block', width: 'auto' }}
            title={
              selectedLayer === 'BlockGroups'
                ? 'About Block Groups'
                : 'About Tracts'
            }
            definition={
              selectedLayer === 'BlockGroups'
                ? blockGroupsDefinition
                : tractsDefinition
            }
          />
          <br /> (
          <a href="https://www.census.gov/" target="_blank" rel="noreferrer">
            U.S. Census Bureau
          </a>
          )
        </p>
      </div>
      <div style={{ display: 'flex', height: '80px' }}>
        {/* <img
            style={{ margin: 'auto' }}
            src={PhoenixLogo}
            alt="Phoenix Logo"
          /> */}

        <img style={{ margin: 'auto' }} src={MagLogo} alt="Mag Logo" />
      </div>
    </>
  );
}
